import { denyRequest } from "../../infrastructure/repository/request-repository";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { translate as t } from "../../infrastructure/translate/localization";

export default async function rejectEducationRequest({
  companyId,
  requestId,
  rejectedReason,
  category,
}: {
  companyId: string;
  requestId: string;
  rejectedReason: string;
  category: string;
}): Promise<void> {
  try {
    await denyRequest({
      companyId,
      category,
      requestId,
      reason: rejectedReason,
    });
    showSuccessMessage(
      t("recurrent-payments-section.education-request-successfully-rejected")
    );
  } catch (error) {
    showErrorMessage(t("common-messages.basic-error-message"));
  }
}
